<template>
	<!-- eslint-disable -->
	
	<div class="match">
		<div class="wrapper">
			<div class="match_row">
				<leagues v-if="leagues" sport="hockey" :data="leagues"></leagues>
				
				<div class="match_right">
					<div class="team">
						<div class="team_main" v-if="teamInfo">
							<div class="team_image">
								<img :src="$hostname + '/goalserve/hockey/team_image/' + teamInfo.id" alt="">
							</div>
							<div class="team_name">{{ teamInfo.name }}</div>
						</div>
						
						<tab :headings="{results: 'Результаты', schedule: 'Календарь'}" active-key="results">
							<template v-slot:results>
								<links v-if="results" sport="hockey" :data="results"></links>
								<div v-else class="info">Нет данных</div>
							</template>
							
							<template v-slot:schedule>
								<links show-date="true" v-if="schedule" sport="hockey" :data="schedule"></links>
								<div v-else class="info">Нет данных</div>
							</template>
						</tab>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'underscore';
	
	import Leagues from "../../Common/Leagues";
	import Tab from "../../../Tab/Tab";
	import Links from "../Components/Events/LinksResult";
	
	export default {
		components: {
			Leagues,
			Tab,
			Links,
		},
		
		data() {
			return {
				id: this.$route.params.id,
				leagues: null,
				league: this.$route.params.league,
				results: null,
				schedule: null,
				teamInfo: null
			}
		},
		
		computed: {
			players() {
				if (!this.team.squad.player) {
					return null
				}
				return _.groupBy(this.team.squad.player, (item) => {
					return item.position;
				});
			},
			transfers() {
				return this.team.transfers || null;
			},
		},
		
		created() {
			this.initLeagues();
			
			this.initTeamInfo();
			
			this.initResults();
			
			this.initSchedule();
		},
		
		methods: {
			initLeagues() {
				this.axios.get('/goalserve/hockey/league')
					.then(({data}) => {
						this.leagues = data;
					});
			},
			initResults() {
				this.axios.get('/goalserve/hockey/league/fixtures?status=finished&league_id=' + this.league + '&team_id=' + this.id)
					.then(({data}) => {
						this.results = data.res;
					});
			},
			initSchedule() {
				this.axios.get('/goalserve/hockey/league/fixtures?status=not_started&league_id=' + this.league + '&team_id=' + this.id)
					.then(({data}) => {
						this.schedule = data.res;
					});
			},
			initTeamInfo() {
				this.axios.get('/goalserve/hockey/league/rosters?team_id=' + this.id)
					.then(({data}) => {
						this.teamInfo = data.res;
					});
			}
		}
	}
</script>